module.exports = __webpack_public_path__ + "static/media/backspace.c9263fb0.svg";